import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import Tooltip from 'components/Tooltip';
import {TOOLTIP_POSITION_RIGHT} from 'components/Tooltip';
import Spinner from 'components/Spinner';
import {SIZE_LARGE} from 'components/Spinner';
import fillWithPlaceholders from 'utils/components/fillWithPlaceholders';
import TypefaceCard from './TypefaceCard';
import TypefaceCardPlaceholder from './TypefaceCardPlaceholder';
import TypefacesSettings from './TypefacesSettings';
import {Request, RequestsMixin, GET, PUT, DELETE} from 'requests';
import ResourcesMatching from 'requests/components/ResourcesMatching';
import Requesting from 'requests/components/Requesting';
import Done from 'requests/components/Done';

const NUMBER_OF_TYPEFACES_NEEDED = 4;
const TYPEFACE_MULTIPLES = 2;

const mapStateToProps = (state, props) => {
  const kitToken = props.kitToken;

  return {
    kitToken,
    requests: state.requests,
  };
};

const TypefacesSummary = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    requests: PropTypes.object.isRequired,
    kitToken: PropTypes.string.isRequired,
  },

  mixins: [RequestsMixin, ImmutableRenderMixin],

  getInitialState() {
    return {
      showSettings: false,
      settingsFocused: false,
      usingFocused: false,
      focusedOn: null,
    };
  },

  componentWillMount() {
    this.setRequest({
      workingSetTypefaces: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces'],
      }),
    });

    this.setRequest({
      subscription: new Request({
        method: GET,
        url: ['api', 'subscriptions'],
      }),
    });

    this.setRequest({
      typefaceSettings: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'typeface-settings'],
      }),
    });

    this.setRequest({
      characterSets: new Request({
        method: GET,
        url: ['api', 'character-sets'],
      }),
    });
  },

  handleUsingFocused() {
    this.setState({usingFocused: !this.state.usingFocused});
  },

  handleSettingsFocused() {
    this.setState({settingsFocused: !this.state.settingsFocused});
  },

  handleSettingsClicked(event) {
    event.preventDefault();

    this.setState({
      showSettings: true,
      settingsFocused: false,
    });
  },

  handleSettingsClosed() {
    this.setState({
      showSettings: false,
    });
  },

  handleSettingsSaved(typefaceSettings) {
    this.setRequest({
      updateTypefaceSettings: new Request({
        method: PUT,
        url: ['api', 'kits', this.props.kitToken, 'typeface-settings'],
        record: typefaceSettings,
      }),
    });

    this.setState({
      showSettings: false,
    });
  },

  handleRemoveWorkingSetTypeface(workingSetTypeface) {
    this.setRequest({
      deleteWorkingSetTypeface: new Request({
        method: DELETE,
        url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces', workingSetTypeface.id],
        record: workingSetTypeface,
      }),
    });
  },

  renderUsingLabel() {
    const {
      workingSetTypefaces: workingSetTypefacesRequest,
      subscription: subscriptionRequest,
    } = this.requests;
    const rm = this.resourceManager();
    const workingSetTypefaces = rm.type(workingSetTypefacesRequest, 'working-set-typefaces').all();
    const subscription = rm.type(subscriptionRequest, 'subscriptions').get();

    const typefacesPerKitAllowed = subscription.workingSetTypefacesAllowed;
    const typefacesAllowed = (typefacesPerKitAllowed === Infinity) ? <span>&infin;</span> : typefacesPerKitAllowed;
    let popover = null;

    if (this.state.usingFocused) {
      popover = (
        <Tooltip
          noIcon={true}
          content={<span>Using {workingSetTypefaces.size} of {typefacesAllowed} typefaces per kit<br />available in your plan</span>}
        />
      );
    }

    return (
      <span className="use-count" onMouseOver={this.handleUsingFocused} onMouseOut={this.handleUsingFocused}>
        {popover}
        Using {workingSetTypefaces.size} of {typefacesAllowed} available
      </span>
    );
  },

  renderSpinner() {
    return (
      <div className="is-loading is-loading-typefaces-summary m-xs-x-0 bg-body p-xs-a-xl br-a">
        <Spinner size={SIZE_LARGE} />
      </div>
    );
  },

  renderTypefaces() {
    const {
      kitToken,
    } = this.props;
    const {
      workingSetTypefaces: workingSetTypefacesRequest,
    } = this.requests;
    const rm = this.resourceManager();
    const workingSetTypefaces = rm.type(workingSetTypefacesRequest, 'working-set-typefaces').all();

    const sortedWorkingSetTypefaces = workingSetTypefaces.sortBy(record => record.createdAt.unix()).reverse();
    const cardElements = sortedWorkingSetTypefaces.take(NUMBER_OF_TYPEFACES_NEEDED).map((workingSetTypeface, index) => {
      return (
        <TypefaceCard
          key={workingSetTypeface.id}
          kitToken={kitToken}
          workingSetTypeface={workingSetTypeface}
          onRemoveTypeface={this.handleRemoveWorkingSetTypeface}
        />
      );
    });

    const elements = fillWithPlaceholders(cardElements, {
      placeholder: TypefaceCardPlaceholder,
      multipleOf: TYPEFACE_MULTIPLES,
      minimum: NUMBER_OF_TYPEFACES_NEEDED,
      props: {kitToken},
    });

    return (
      <div className="grid-assets grid-assets-sm grid-assets-xs-2 kit-assets kit-assets-typefaces-sm">
        {elements}
      </div>
    );
  },

  render() {
    const {
      kitToken,
    } = this.props;
    const {
      workingSetTypefaces: workingSetTypefacesRequest,
      subscription: subscriptionRequest,
      typefaceSettings: typefaceSettingsRequest,
      characterSets: characterSetsRequest,
    } = this.requests;
    const rm = this.resourceManager();
    const workingSetTypefaces = rm.type(workingSetTypefacesRequest, 'working-set-typefaces').all();
    const typefaceSettings = rm.type(typefaceSettingsRequest, 'typeface-settings').get();
    const characterSets = rm.type(characterSetsRequest, 'character-sets').all();

    const {settingsFocused} = this.state;

    const addLabel = (workingSetTypefaces && workingSetTypefaces.size > 0) ? 'Add' : 'Add your first TYPEFACE';
    const popover = (settingsFocused) ? <Tooltip noIcon={true} content="Typeface Settings" position={TOOLTIP_POSITION_RIGHT} /> : null;
    const settingsDataLoaded = rm.requests.isDone(typefaceSettingsRequest) && rm.requests.isDone(characterSetsRequest);

    return (
      <ResourcesMatching manager={rm}>
        <div className="kit-asset-summary m-xs-b-lg">
          <div className="kit-asset-header gg gg-bottom">
            <h3 className="kit-asset-title gg-col">
              <Link to={`/kits/${kitToken}/typefaces`} className="link-dashed-none">Typefaces</Link>
              &nbsp;&thinsp;
              <a
                href="#"
                className="text-muted text-lg has-tooltip link-dashed-none"
                onClick={this.handleSettingsClicked}
                onMouseOver={this.handleSettingsFocused}
                onMouseOut={this.handleSettingsFocused}
              >
                {popover}
                <Done all={[typefaceSettingsRequest, characterSetsRequest]}>
                  <i className="ficon ficon-gear" />
                </Done>
              </a>
            </h3>
            <div className="kit-asset-actions gg-col text-xs-right text-muted">
              <Link to={`/kits/${kitToken}/typefaces/new`} className="link-dashed-none m-xs-r-md">
                <i className="ficon ficon-plus-circle m-xs-r-xs"></i>{addLabel}
              </Link>
              <Link to={`/kits/${kitToken}/typefaces/upload`} className="link-dashed-none">
                <i className="ficon ficon-uploaded m-xs-r-xs"></i>Upload
              </Link>
            </div>
          </div>
          <hr className="m-xs-y-sm" />
          <Requesting request={workingSetTypefacesRequest} render={this.renderSpinner} />
          <Done request={workingSetTypefacesRequest} render={this.renderTypefaces} />
          <hr className="m-xs-y-sm" />
          <div className="text-muted m-xs-b-md text-xs-right">
            <Done request={subscriptionRequest} render={this.renderUsingLabel} />
            &nbsp;&middot; <a href="/upgrade">Get More</a>
          </div>
          <TypefacesSettings
            show={this.state.showSettings && settingsDataLoaded}
            typefaceSettings={typefaceSettings}
            characterSets={characterSets}
            onClosed={this.handleSettingsClosed}
            onSaved={this.handleSettingsSaved}
          />
        </div>
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(TypefacesSummary);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/TypefacesSummary.js